import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, SaveBasicDetails } from '../shared/model/response-format';
import { AppUsersDto } from '../shared/model/app-users-dto';
import { uploadPdfResponseDto } from './profile-details/profile-details.component';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../shared/service/logged-in-user.service';
import { ValidationUtils } from '../shared/utils/Validators';
import { Router } from '@angular/router';
import { CommonService } from '../shared/service/common.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.baseUrl;
  apiUrls = {
    getSpecialization: '/api/v1/user/get-specialization',
    getCourses: '/api/v1/user/get-course',
    saveResume: '/api/v1/user/upload-profile-details',
    deleteResume: '/api/v1/file/delete-resume',
    saveBasicDetails: '/api/v1/user/save-basic-details',
    uploadResume: 'https://f360ai.foyr.com/analyzePDF',
    saveDocument: '/api/v1/user/save-document',
    deleteFileById: '/api/v1/file/delete-by-fileId',
    saveCandidateResume: '/api/v1/file/upload-resume',
    uploadCandidateResume: '/api/v1/resume/parse-resume',
    getSkillSet: '/api/v1/candidate-skill/get-all',
    getCoursesAndSpecialization:
      '/api/v1/candidate-course-specialization/get-all-courses',
    getResumeUrl: '/api/v1/file/get-resume-url',
    getFFFQuestion:
      'https://pixiproductmasterstaging.foyr.com/api/autodeploymentai/fffQuesAssessment',
    saveFFFQuestion: '/api/v1/candidate-audio-question/save-audio-question',
    saveMultipleAudioQuestion:
      '/api/v1/candidate-audio-question/save-multiple-audio-question',
    ssoURL: '/oauth2/authorization/cognito',
    tokenUrl: '/auth/token',
    getSSOInfo: '/api/v1/auth/sso/info',
    getOTPForAVUser: '/api/v1/auth/av/signup/verify/sendotp',
    verifyOtpForAVUser: '/api/v1/auth/av/signup/verify/otp',
    processCandidateResumeBase64: '/api/v1/file/process-resume-base64',
    // http://34.60.214.85:8084/uploadResume?s3_url=https://f360-production.s3.ca-central-1.amazonaws.com/resume/12121.pdf
  };
  constructor(
    private _http: HttpClient,
    private _loggedInUserService: LoggedInUserService,
    private router: Router,
    private _commonService: CommonService,
  ) {}

  getAllCourse(): Observable<ApiResponse<string>> {
    return this._http.get<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.getCourses,
    );
  }
  getAllSkillList(): Observable<ApiResponse<string>> {
    return this._http.get<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.getSkillSet,
    );
  }
  getAllCoursesAndSpecialization(): Observable<ApiResponse<string>> {
    return this._http.get<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.getCoursesAndSpecialization,
    );
  }

  getAllSpecialization(requestPayload): Observable<ApiResponse<string>> {
    return this._http.post<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.getSpecialization,
      requestPayload,
    );
  }

  saveResume(formData: FormData): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.baseUrl + this.apiUrls.saveResume,
      formData,
    );
  }
  deleteResume(): Observable<ApiResponse<any>> {
    return this._http.delete<ApiResponse<any>>(
      this.baseUrl + this.apiUrls.deleteResume,
    );
  }

  saveResumeForFFF(formData: FormData): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.apiUrls.getFFFQuestion,
      formData,
    );
  }

  saveFFFQuestion(formData: any): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.baseUrl + this.apiUrls.saveFFFQuestion,
      formData,
    );
  }

  saveMultipleAudioQuestion(
    requestPayload: any,
  ): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.baseUrl + this.apiUrls.saveMultipleAudioQuestion,
      requestPayload,
    );
  }

  saveBasicDetail(requestPayload): Observable<ApiResponse<SaveBasicDetails>> {
    return this._http.post<ApiResponse<SaveBasicDetails>>(
      this.baseUrl + this.apiUrls.saveBasicDetails,
      requestPayload,
    );
  }

  uploadResume(requestPayload: FormData): Observable<uploadPdfResponseDto> {
    return this._http.post<uploadPdfResponseDto>(
      this.apiUrls.uploadResume,
      requestPayload,
    );
  }

  saveDocument(requestPayload): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.saveDocument,
      requestPayload,
    );
  }

  deleteFileById(fileId): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.deleteFileById,
      fileId,
    );
  }

  uploadCandidateResume(formData?: any): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.uploadCandidateResume,
    );
  }

  saveCandidateResume(
    formData: FormData,
  ): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.baseUrl + this.apiUrls.saveCandidateResume,
      formData,
    );
  }

  processCandidateResumeBase64(
    payLoad: any,
  ): Observable<ApiResponse<AppUsersDto>> {
    return this._http.post<ApiResponse<AppUsersDto>>(
      this.baseUrl + this.apiUrls.processCandidateResumeBase64,
      payLoad,
    );
  }

  getResumeUrl(): Observable<ApiResponse<string>> {
    return this._http.get<ApiResponse<string>>(
      this.baseUrl + this.apiUrls.getResumeUrl,
    );
  }

  isUserRedirect: boolean = false;
  redirectUserLoggedInOrNot(path: string) {
    console.log(path, 'path');

    let loggedInUser: AppUsersDto = this._loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER,
    );
    if (
      loggedInUser &&
      !ValidationUtils.isStringNull(loggedInUser.authToken) &&
      loggedInUser.userRole == 'CANDIDATE'
    ) {
      if (loggedInUser.isFirstTimeLogin) {
        this.router.navigate([
          this._commonService.Navigations.NEW_PROFILE_DETAILS,
        ]);
        // this.router.navigate([this._commonService.Navigations.BASIC_DETAILS]);
      } else if (
        !loggedInUser.isFirstTimeLogin &&
        !loggedInUser.isEmailVerified
      ) {
        this.router.navigate([this._commonService.Navigations.VERIFY_EMAIL]);
      } else if (
        !loggedInUser.isProfileDetailsUpdated &&
        loggedInUser.isEmailVerified
      ) {
        this.router.navigate([
          this._commonService.Navigations.NEW_PROFILE_DETAILS,
        ]);
      } else if (
        !loggedInUser.isFirstTimeLogin &&
        loggedInUser.isProfileDetailsUpdated &&
        loggedInUser.hasRegisteredDrives
      ) {
        this.router.navigate([
          this._commonService.Navigations.DASHBOARD_ASSESSMENT,
        ]);
      } else if (
        !loggedInUser.isFirstTimeLogin &&
        loggedInUser.isProfileDetailsUpdated &&
        !loggedInUser.hasRegisteredDrives
      ) {
        this.router.navigate([this._commonService.Navigations.DASHBOARD]);
      }
    } else if (
      loggedInUser &&
      !ValidationUtils.isStringNull(loggedInUser.authToken) &&
      (loggedInUser.userRole == 'FRACTAL_ADMIN' ||
        loggedInUser.userRole == 'FRACTAL_HR')
    ) {
      const targetRoute =
        loggedInUser.userRole === 'FRACTAL_ADMIN'
          ? this._commonService.Navigations.ADMIN_USER_DASHBOARD
          : this._commonService.resolveLoginPath(
              this._commonService.Navigations.HR_USER_DASHBOARD,
              loggedInUser.isPmViewEnabled,
            );
      this.router.navigateByUrl(targetRoute);
    } else {
      if (!this.isUserRedirect) {
        switch (path) {
          case 'signin':
            this.router.navigate(['/sign-in']);
            break;
          case 'homepage':
            this.router.navigate(['']);
            break;
          default:
            this.router.navigate(['/sign-in']);
        }
        this.isUserRedirect = true;
      }
    }
  }

  getSSOLogin(loginType: string = 'candidate') {
    window.location.href =
      this.baseUrl + this.apiUrls.ssoURL + '?login_type=' + loginType;

    // return this._http
    //   .get<any>(this.baseUrl + this.apiUrls.ssoURL, {
    //     observe: 'response', // Ensure we observe the full response
    //     withCredentials: true, // Include cookies if necessary
    //   })
    //   .pipe(
    //     map((response) => {
    //       console.log('Full Response:', response); // Log the full response to the console
    //       console.log('Response Headers:', response.headers); // Log the headers to check for Location

    //       // Check for a 302 status and handle the Location header
    //       if (response.status === 302) {
    //         const redirectUrl = response.headers.get('Location');
    //         if (redirectUrl) {
    //           console.log('Redirecting to:', redirectUrl);
    //           window.location.href = redirectUrl; // Redirect to the SSO URL
    //         } else {
    //           console.error('No Location header found in the response');
    //         }
    //       }

    //       // Return the response (you might still want to return the response object here for debugging)
    //       return response;
    //     })
    //   );
  }

  getToken(sub: string) {
    return this._http.get<any>(
      this.baseUrl + this.apiUrls.tokenUrl + '/' + sub,
    );
  }

  getSSOInfo(ssoInfo) {
    return this._http.post(this.baseUrl + this.apiUrls.getSSOInfo, ssoInfo);
  }

  ssoCallback(path: string) {
    setTimeout(() => {
      window.location.href = this.baseUrl + path;
    }, 1500);
  }

  getOTPForAVUser(data: any) {
    return this._http.post(this.baseUrl + this.apiUrls.getOTPForAVUser, data);
  }
  verifyOtpForAVUser(data: any) {
    return this._http.post(
      this.baseUrl + this.apiUrls.verifyOtpForAVUser,
      data,
    );
  }
}
